import { useEffect, useRef, useState } from 'react';

import { useSocketConnectionContext } from '@web/components/SocketConnectionProvider/SocketConnectionProvider';
import { IncomingCommand } from '@web/components/SocketConnectionProvider/types/command';

export const useMessagesRefetchCounter = (isFetchingMessages: boolean) => {
  const { subscribe } = useSocketConnectionContext();
  const isFetchInProgress = useRef(isFetchingMessages);
  const reconnectionCounter = useRef(0);
  const [refetchCounter, setRefetchCounter] = useState(0);

  useEffect(
    () =>
      subscribe(IncomingCommand.SOCKET_RECONNECT, () => {
        reconnectionCounter.current += 1;
      }),
    [subscribe]
  );

  useEffect(() => {
    const isSyncingAfterReconnection = reconnectionCounter.current > refetchCounter;
    if (!isSyncingAfterReconnection) return;

    if (isFetchingMessages) {
      isFetchInProgress.current = true;
      return;
    }

    const isFetched = !isFetchingMessages && isFetchInProgress.current;
    if (!isFetched) return;

    isFetchInProgress.current = false;
    setRefetchCounter((v) => ++v);
  }, [isFetchingMessages, refetchCounter]);

  return refetchCounter;
};
